import React from 'react';
/**
 *
 * STANDARD COMPONENTS
 *
 * */
import App, { AppProps } from './components/app/App';
import ErrorBoundary from './components/errorboundary/ErrorBoundary';
import Footer, { FooterProps } from './components/footer/Footer';
import Header, { HeaderProps } from './components/header/Header';
import Loading, { LoadingProps } from './components/loading/Loading';

type ComponentClassAsync<T> = Promise<{ default: React.ComponentClass<T> }>;

export class ComponentFactory {
  static get<T>(component: any): new () => React.Component<T> {
    return component;
  }

  static getAsync<T>(component: any): ComponentClassAsync<T> {
    return component;
  }

  static get AcceptInvitationAsync() {
    return import(/* webpackChunkName: "AcceptInvitation" */ './components/acceptinvitation/AcceptInvitation');
  }

  static get App() {
    return ComponentFactory.get<AppProps>(App);
  }

  static get EmailFormAsync() {
    return import(/* webpackChunkName: "EmailForm" */ './components/emailform/EmailForm');
  }

  static get ErrorBoundary() {
    return ComponentFactory.get(ErrorBoundary);
  }

  static get ErrorPageAsync() {
    return import(/* webpackChunkName: "ErrorPage" */ './pages/errorpage/ErrorPage');
  }

  static get Footer() {
    return ComponentFactory.get<FooterProps>(Footer);
  }

  static get Header() {
    return ComponentFactory.get<HeaderProps>(Header);
  }

  static get HomeAsync() {
    return import(/* webpackChunkName: "Home" */ './pages/home/Home');
  }

  static get InfoCardAsync() {
    return import(/* webpackChunkName: "InfoCard" */ './components/infocard/InfoCard');
  }

  static get InvitationsAsync() {
    return import(/* webpackChunkName: "Invitations" */ './pages/invitations/Invitations');
  }

  static get Loading() {
    return ComponentFactory.get<LoadingProps>(Loading);
  }

  static get MultiFactorInfoAsync() {
    return import(/* webpackChunkName: "MultiFactorInfo" */ './components/multifactorinfo/MultiFactorInfo');
  }

  static get MultiFactorVerificationAsync() {
    return import(
      /* webpackChunkName: "MultiFactorVerification" */ './pages/multifactorverification/MultiFactorVerification'
    );
  }

  static get NavBarAsync() {
    return import(/* webpackChunkName: "NavBar" */ './components/navbar/NavBar');
  }

  static get PasswordFormAsync() {
    return import(/* webpackChunkName: "PasswordForm" */ './components/passwordform/PasswordForm');
  }

  static get PasswordInfoAsync() {
    return import(/* webpackChunkName: "PasswordInfo" */ './components/passwordinfo/PasswordInfo');
  }

  static get PhoneVerificationAsync() {
    return import(/* webpackChunkName: "PhoneVerification" */ './pages/phoneverification/PhoneVerification');
  }

  static get ProfileAsync() {
    return import(/* webpackChunkName: "Profile" */ './pages/profile/Profile');
  }

  static get ProfileFormAsync() {
    return import(/* webpackChunkName: "ProfileForm" */ './components/profileform/ProfileForm');
  }

  static get ProfileInfoAsync() {
    return import(/* webpackChunkName: "ProfileInfo" */ './components/profileinfo/ProfileInfo');
  }

  static get ResetPasswordAsync() {
    return import(/* webpackChunkName: "ResetPassword" */ './pages/resetpassword/ResetPassword');
  }

  static get SecurityAsync() {
    return import(/* webpackChunkName: "Security" */ './pages/security/Security');
  }

  static get SignInAsync() {
    return import(/* webpackChunkName: "SignIn" */ './pages/signin/SignIn');
  }

  static get SignInFormAsync() {
    return import(/* webpackChunkName: "SignInForm" */ './components/signinform/SignInForm');
  }
}
